<template>
  <div>
    <div class="section">
      <div class="container">
        <div class="row py-5">
          <div class="col-md-4 col-lg-4 d-none d-sm-none d-md-block">
            <SearchFilters />
          </div>

          <div class="col d-block d-sm-block d-md-none mb-3">
            <div class="card">
              <div class="card-header p-0">
                <button
                  class="btn btn-primary btn-block"
                  @click="showMobileFilters = !showMobileFilters"
                >
                  {{ content.filters }}
                </button>
              </div>
              <div v-show="showMobileFilters" class="card-body">
                <SearchFilters />
                <button
                  class="btn btn-primary w-100 text-center mt-3"
                  @click="showMobileFilters = !showMobileFilters"
                >
                  {{ content.close }}
                </button>
              </div>
            </div>
          </div>

          <div v-if="isInitializing" class="col-md-8 col-lg-8">
            <ListContentLoader :sections="3" :rows-per-section="2" />
          </div>
          <div v-else class="col-md-8 col-lg-8">
            <SearchResults />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import ListContentLoader from '@/src/components/ListContentLoader.vue';
import { store } from '@/src/rootStore';

import SearchFilters from './SearchFilters.vue';
import SearchResults from './SearchResults.vue';
import { action, mutation } from './store';

const { mapGetters } = createNamespacedHelpers('search');

export default {
  name: 'Search',

  components: {
    SearchFilters,
    SearchResults,
    ListContentLoader,
  },

  props: {
    /** @type {import('vue').PropOptions<import('./store/state').SearchContent>} */
    localizedContent: {
      type: Object,
      required: true,
    },
    /** @type {import('vue').PropOptions<import('./store/state').SearchContext>} */
    context: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showMobileFilters: false,
    };
  },

  store,

  computed: {
    ...mapGetters(['isInitializing', 'content']),
  },

  async created() {
    this.$store.commit(mutation('SET_CONTENT_AND_CONTEXT'), {
      context: this.context,
      content: this.localizedContent,
    });

    this.$store.commit(mutation('SET_INITIALIZING'), true);

    await this.$store.dispatch(action('INITIALIZE_FILTER_STATE'));

    await this.$store.dispatch(action('LOAD_SEARCH_RESULTS'), true);

    this.$store.commit(mutation('SET_INITIALIZING'), false);

    /**
     * Because the browser can load the page from memory using
     * the bfcache (https://web.dev/bfcache/), we need to ensure
     * changes in the URL (back/forward navigation) result in
     * changes to the state of the app.
     * The 'popstate' event is emitted every time the back/foward
     * navigation is used in the browser, but not when we use
     * history.pushState()
     */
    window.addEventListener('popstate', () =>
      this.$store.dispatch(action('REFRESH_FILTER_STATE')),
    );
  },
};
</script>
